import React from 'react';
import { motion } from 'framer-motion';
const oldTools = ['Answering service', 'CRM', 'Review tool', 'Ad platform', 'Invoicing app'];

/* Makes "one system instead of fifty logins" (already a headline claim on
   this site) visible instead of just stated: the separate tools this
   package replaces, each struck through, converging into one node. Static
   layout, no animation loop -- the whileInView stagger is the only motion,
   matching sections like Onboarding/System that don't run continuously. */
export function ConsolidationVisual() {
  return <div className="mx-auto flex w-full max-w-xl flex-col items-center gap-6 sm:flex-row sm:justify-center sm:gap-4" data-id="element-547" data-mp="20njgxi43lf5d">
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-1" data-id="element-548" data-mp="1vnyhl6l0n4s4">
        {oldTools.map((tool, i) => <motion.div key={tool} initial={{
        opacity: 0,
        x: -8
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.35,
        delay: i * 0.06
      }} className="rounded-lg border border-[#1c1c1c] bg-[#0d0d0d] px-3.5 py-2 text-center sm:text-left" data-id="element-549" data-mp="3c26ra0kotjmc" data-mpi={i}>
            <span className="text-xs text-neutral-500 line-through decoration-neutral-700" data-id="element-550" data-mp="130dafnihcdva">
              {tool}
            </span>
          </motion.div>)}
      </div>

      <svg className="hidden h-16 w-12 shrink-0 sm:block" viewBox="0 0 48 64" aria-hidden="true" data-id="element-551" data-mp="1cvx6c9x1nck1">
        <motion.path d="M 0 8 L 24 32 L 0 56 M 0 32 L 24 32 L 48 32" fill="none" stroke="#232323" strokeWidth="1.5" strokeLinecap="round" initial={{
        pathLength: 0,
        opacity: 0
      }} whileInView={{
        pathLength: 1,
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-552" data-mp="fardl6pkyaqg" />
      </svg>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.4,
      delay: 0.5
    }} className="flex h-24 w-24 shrink-0 flex-col items-center justify-center rounded-full border-2 border-emerald-500/50 bg-emerald-500/10 text-center" data-id="element-553" data-mp="3sm05m6ug560r">
        <span className="font-mono text-[10px] uppercase tracking-[0.1em] text-emerald-500" data-id="element-554" data-mp="35viyyzgpasf">
          One
        </span>
        <span className="text-sm font-bold text-white" data-id="element-555" data-mp="3ufas43l25rfp">System</span>
      </motion.div>
    </div>;
}